import React from 'react';
import { ScissorsIcon, DropletIcon, RotateCwIcon, GlassWaterIcon, ArrowRightIcon } from 'lucide-react';
import { STEPS } from '../data/content';
import { Section, Reveal, Eyebrow } from './Section';
const ICONS = [ScissorsIcon, DropletIcon, RotateCwIcon, GlassWaterIcon];
export function HowToUse() {
  return <Section className="py-16 md:py-20" data-id="element-165" data-mp="21mfr3b0we7fq">
      <Reveal className="mx-auto max-w-2xl text-center" data-id="element-166" data-mp="21nhf0g30ioev">
        <Eyebrow data-id="element-167" data-mp="1dwv7qr0u185x">How To Use</Eyebrow>
        <h2 className="mt-5 font-serif text-3xl font-medium leading-tight text-forest sm:text-4xl lg:text-[2.75rem]" data-id="element-168" data-mp="1dxwisvhulunn">
          Your one-minute morning ritual
        </h2>
      </Reveal>

      <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-4" data-id="element-169" data-mp="1nvknoe964ijj">
        {STEPS.map((step, i) => {
        const Icon = ICONS[i];
        return <Reveal key={step.n} delay={i * 0.08} data-id="element-170" data-mp="2z8dftq5vf904" data-mpi={i}>
              <div className="relative flex h-full flex-col items-center rounded-2xl border border-forest/10 bg-ivory/60 p-8 text-center" data-id="element-171" data-mp="2zb9ejgpjm1pm">
                <span className="absolute right-5 top-4 font-serif text-3xl text-sage/30" data-id="element-172" data-mp="3d1nzdjduoaa">{step.n}</span>
                <span className="flex h-16 w-16 items-center justify-center rounded-full bg-forest text-ivory" data-id="element-173" data-mp="8atpmz9txoro">
                  <Icon className="h-7 w-7" data-id="element-174" data-mp="dbr7tbuuait6" />
                </span>
                <h3 className="mt-5 font-serif text-xl text-forest" data-id="element-175" data-mp="i9iy61fu5wv9">{step.title}</h3>
                <p className="mt-2 text-sm text-forest/70" data-id="element-176" data-mp="i7g6lcz1bvof">{step.desc}</p>
              </div>
              {i < STEPS.length - 1 && <ArrowRightIcon className="mx-auto mt-4 hidden h-5 w-5 rotate-90 text-sage lg:hidden" data-id="element-177" data-mp="3lpq30b9zm05m" />}
            </Reveal>;
      })}
      </div>
    </Section>;
}